(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-mileoff"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      const forms = root.querySelectorAll('.mileoff-email-signup__form');

      forms.forEach((form) => {
        if (form.dataset.newsletterAjaxInitialized === 'true') return;
        form.dataset.newsletterAjaxInitialized = 'true';

        const section = form.closest('.mileoff-email-signup');
        if (!section) return;

        const input = form.querySelector('.mileoff-email-signup__input');
        const submitButton = form.querySelector('.mileoff-email-signup__button');
        const successMessage = section.querySelector('.mileoff-email-signup__message--success-js');
        const errorMessage = form.querySelector('.mileoff-email-signup__message--error');
        const endpoint = form.getAttribute('action') || '/contact';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }

          if (submitButton) submitButton.disabled = true;
          if (errorMessage) errorMessage.hidden = true;

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              body: new FormData(form),
              headers: {
                Accept: 'text/html'
              }
            });

            if (!response.ok) {
              throw new Error(`Newsletter signup failed (${response.status})`);
            }

            section.classList.add('is-success');
            if (successMessage) successMessage.hidden = false;
            if (input) input.value = '';
          } catch (error) {
            if (errorMessage) errorMessage.hidden = false;
          } finally {
            if (submitButton) submitButton.disabled = false;
          }
        });
      });
    };

    const initOnReady = () => init(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOnReady, { once: true });
    } else {
      initOnReady();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mileoff-product-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const removeInfiniteCarousel = (section) => {
      const grid = section?.querySelector?.('.mileoff-shop-look__grid');
      if (!grid) return;

      const clones = grid.querySelectorAll('[data-loop-clone="true"]');
      clones.forEach((clone) => clone.remove());
      grid.dataset.infiniteReady = 'false';
    };

    const setupInfiniteCarousel = (section) => {
      if (!section || section.dataset.mobileInfiniteLoop !== 'true') return;
      if (!mobileQuery.matches) {
        removeInfiniteCarousel(section);
        return;
      }

      const grid = section.querySelector('.mileoff-shop-look__grid');
      if (!grid || !section.classList.contains('mileoff-shop-look--mobile-carousel')) return;
      if (grid.dataset.infiniteReady === 'true') return;

      const cards = [...grid.children].filter((node) => !node.hasAttribute('data-loop-clone'));
      if (cards.length < 2) return;

      const firstClone = cards[0].cloneNode(true);
      firstClone.setAttribute('data-loop-clone', 'true');
      const lastClone = cards[cards.length - 1].cloneNode(true);
      lastClone.setAttribute('data-loop-clone', 'true');

      grid.insertBefore(lastClone, cards[0]);
      grid.appendChild(firstClone);

      const cardStep = () => {
        const firstCard = grid.querySelector('.mileoff-shop-look__card');
        if (!firstCard) return 0;
        const gap = Number.parseFloat(window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap || '0') || 0;
        return firstCard.getBoundingClientRect().width + gap;
      };

      const jumpTo = (target) => {
        const previousBehavior = grid.style.scrollBehavior;
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft = target;
        grid.style.scrollBehavior = previousBehavior;
      };

      const initializePosition = () => {
        const step = cardStep();
        if (step > 0) jumpTo(step);
      };

      let ticking = false;
      const handleScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const step = cardStep();
          if (step <= 0) {
            ticking = false;
            return;
          }

          const min = step * 0.35;
          const max = step * (cards.length + 0.65);

          if (grid.scrollLeft <= min) {
            jumpTo(grid.scrollLeft + cards.length * step);
          } else if (grid.scrollLeft >= max) {
            jumpTo(grid.scrollLeft - cards.length * step);
          }

          ticking = false;
        });
      };

      initializePosition();
      grid.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', initializePosition);
      grid.dataset.infiniteReady = 'true';
    };

    const init = () => {
      document.querySelectorAll('.mileoff-shop-look').forEach(setupInfiniteCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    mobileQuery.addEventListener('change', init);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target?.querySelector?.('.mileoff-shop-look') || event.target;
      if (section?.classList?.contains('mileoff-shop-look')) {
        setupInfiniteCarousel(section);
      } else {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mileoff-race-kit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('.mileoff-race-kit[id^="MileoffRaceKit-"]');
    if (!section) return;

    const blocks = section.querySelectorAll('.mileoff-race-kit__block');
    if (!blocks.length) return;
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const prefersReducedMotion = reducedMotionQuery.matches;
    const blockExitSlideMs = 180;
    const blockCollapseMs = 380;

    const parseProducts = (el) => {
      try {
        return JSON.parse(el.dataset.products || '[]');
      } catch (e) {
        return [];
      }
    };

    const getOptionIndex = (options, name) => {
      const idx = options.findIndex((opt) => opt && opt.toLowerCase() === name);
      if (idx !== -1) return idx;
      return options.findIndex((opt) => opt && opt.toLowerCase().includes(name));
    };

    const buildUnique = (list) => Array.from(new Set(list.filter(Boolean)));
    const normalizeSubtypeValue = (value) => String(value || '').trim().toLowerCase();
    const normalizeSubtypes = (value) => {
      if (Array.isArray(value)) return value.map(normalizeSubtypeValue).filter(Boolean);
      if (value === null || value === undefined || value === '') return [];
      return [normalizeSubtypeValue(value)];
    };

    if (!prefersReducedMotion && typeof IntersectionObserver !== 'undefined') {
      section.classList.add('is-observing');
      const blockRevealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            blockRevealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      blocks.forEach((block) => blockRevealObserver.observe(block));
    } else {
      blocks.forEach((block) => block.classList.add('is-visible'));
    }

    blocks.forEach((block) => {
      const baseProducts = parseProducts(block);
      if (!baseProducts.length) return;

      const resolveAnyImage = (product) => {
        if (!product) return '';
        const firstVariantImage = Array.isArray(product.variants)
          ? (product.variants.find((variant) => Boolean(variant?.featuredImage))?.featuredImage ?? '')
          : '';

        return product.racekitImage || product.featuredImage || firstVariantImage || '';
      };

      const buildExpandedProducts = (list) => {
        const expanded = [];
        const seenGroupSignatures = new Set();

        list.forEach((baseProduct, baseIndex) => {
          if (!baseProduct) return;

          const swatchCandidates = Array.isArray(baseProduct.swatchProducts) ? baseProduct.swatchProducts : [];
          const orderedGroupProducts = [];
          const seenGroupIds = new Set();

          const addGroupProduct = (candidate) => {
            if (!candidate) return;
            const candidateId = String(candidate.id || '');
            if (!candidateId || seenGroupIds.has(candidateId)) return;
            if (!resolveAnyImage(candidate)) return;
            seenGroupIds.add(candidateId);
            orderedGroupProducts.push(candidate);
          };

          swatchCandidates.forEach(addGroupProduct);
          addGroupProduct(baseProduct);

          if (!orderedGroupProducts.length) return;

          const orderedGroupIds = orderedGroupProducts.map((groupProduct) => String(groupProduct.id || ''));
          const normalizedSignature = orderedGroupIds
            .filter(Boolean)
            .slice()
            .sort()
            .join('|');
          if (!normalizedSignature) return;
          if (seenGroupSignatures.has(normalizedSignature)) return;
          seenGroupSignatures.add(normalizedSignature);

          const groupSubtypes = buildUnique(
            orderedGroupProducts.flatMap((groupProduct) => normalizeSubtypes(groupProduct?.subtypes))
          );

          const groupKey = `group-${baseIndex}-${orderedGroupIds[0] || baseIndex}`;
          orderedGroupProducts.forEach((groupProduct, groupIndex) => {
            expanded.push({
              ...groupProduct,
              subtypes: groupSubtypes,
              swatchProducts: orderedGroupProducts,
              groupProductIds: orderedGroupIds,
              groupKey,
              entryKey: `${groupKey}-${groupIndex}-${String(groupProduct.id || groupIndex)}`,
            });
          });
        });

        return expanded;
      };

      const products = buildExpandedProducts(baseProducts);
      if (!products.length) return;

      const productsById = new Map();
      const cacheProduct = (candidate) => {
        if (!candidate) return;
        const candidateId = String(candidate.id || '');
        if (!candidateId || productsById.has(candidateId)) return;
        productsById.set(candidateId, candidate);
      };

      baseProducts.forEach((baseProduct) => {
        cacheProduct(baseProduct);
        if (Array.isArray(baseProduct?.swatchProducts)) {
          baseProduct.swatchProducts.forEach(cacheProduct);
        }
      });
      products.forEach(cacheProduct);

      const imageEl = block.querySelector('.mileoff-race-kit__image');
      const titleEl = block.querySelector('.mileoff-race-kit__product-title');
      const swatchesEl = block.querySelector('.mileoff-race-kit__swatches');
      const sizesEl = block.querySelector('.mileoff-race-kit__sizes');
      const sizeGuideBtn = block.querySelector('.mileoff-race-kit__size-guide');
      const dialog = block.querySelector('.mileoff-race-kit__dialog');
      const dialogImage = block.querySelector('.mileoff-race-kit__dialog-image');
      const dialogClose = block.querySelector('.mileoff-race-kit__dialog-close');
      const prevBtn = block.querySelector('.mileoff-race-kit__arrow--prev');
      const nextBtn = block.querySelector('.mileoff-race-kit__arrow--next');
      const mediaRow = block.querySelector('.mileoff-race-kit__media-row');
      const filters = Array.from(block.querySelectorAll('.mileoff-race-kit__filter'));
      const closeBtn = block.querySelector('.mileoff-race-kit__close');

      const imageCache = new Map();
      let imageTransitionToken = 0;

      let currentIndex = 0;
      let activeFilter = null;
      let activeSize = null;
      let currentProductId = null;
      let currentEntryKey = null;

      const syncBlockHeight = () => {
        if (block.classList.contains('is-hidden')) return;
        block.style.setProperty('--race-kit-block-max-height', `${block.scrollHeight}px`);
      };

      const availableSubtypeSet = new Set();
      products.forEach((product) => {
        normalizeSubtypes(product?.subtypes).forEach((subtype) => availableSubtypeSet.add(subtype));
      });

      filters.forEach((filter) => {
        const filterValue = normalizeSubtypeValue(filter.dataset.filter || '');
        if (!filterValue) return;
        const isAvailable = availableSubtypeSet.has(filterValue);
        filter.hidden = !isAvailable;
        filter.disabled = !isAvailable;
      });

      const initialFilter = filters.find(
        (filter) => !filter.hidden && !filter.disabled && filter.classList.contains('is-active')
      );
      if (initialFilter) {
        const initialFilterValue = normalizeSubtypeValue(initialFilter.dataset.filter || '');
        activeFilter = initialFilterValue || null;
      } else if (filters[0]) {
        const firstVisibleFilter = filters.find((filter) => !filter.hidden && !filter.disabled) || filters[0];
        const firstFilterValue = normalizeSubtypeValue(firstVisibleFilter.dataset.filter || '');
        activeFilter = firstFilterValue || null;
        firstVisibleFilter.classList.add('is-active');
      }

      const filteredProducts = () => {
        if (!activeFilter) return products;
        return products.filter((p) => normalizeSubtypes(p.subtypes).includes(activeFilter));
      };

      const getOptionIndexes = (product) => {
        const options = product?.options || [];
        return {
          sizeIndex: getOptionIndex(options, 'size')
        };
      };

      const getSizeData = (product) => {
        const { sizeIndex } = getOptionIndexes(product);
        if (sizeIndex === -1) return [];

        const variants = product?.variants || [];
        const sizes = buildUnique(variants.map((variant) => variant.options[sizeIndex]));

        return sizes.map((size) => {
          const sizeVariants = variants.filter((variant) => variant.options[sizeIndex] === size);
          return {
            value: size,
            available: sizeVariants.some((variant) => Boolean(variant.available))
          };
        });
      };

      const getPreferredSizeValue = (sizeData) => {
        if (!Array.isArray(sizeData) || !sizeData.length) return null;
        const firstAvailable = sizeData.find((size) => size.available);
        return (firstAvailable || sizeData[0]).value || null;
      };

      const getSwatchProducts = (product) => {
        if (!product) return [];

        const swatchProducts = [];
        const seen = new Set();
        const addSwatchProduct = (candidate) => {
          if (!candidate) return;
          const candidateId = String(candidate.id || '');
          if (!candidateId || seen.has(candidateId)) return;
          if (!(candidate.productColourValue || candidate.productColourName)) return;
          seen.add(candidateId);
          swatchProducts.push(candidate);
        };

        const groupProductIds = Array.isArray(product.groupProductIds) ? product.groupProductIds : [];
        groupProductIds.forEach((id) => addSwatchProduct(productsById.get(String(id))));

        if (!swatchProducts.length && Array.isArray(product.swatchProducts)) {
          product.swatchProducts.forEach(addSwatchProduct);
        }
        if (!swatchProducts.length) {
          addSwatchProduct(product);
        }

        return swatchProducts;
      };

      const resolveVariant = (product) => {
        if (!product || !product.variants) return null;
        const { sizeIndex } = getOptionIndexes(product);
        const variants = product.variants;
        if (sizeIndex !== -1 && activeSize) {
          const sizeMatch = variants.find((v) => v.options[sizeIndex] === activeSize);
          if (sizeMatch && sizeMatch.available) return sizeMatch;
        }
        const firstAvailable = variants.find((variant) => Boolean(variant.available));
        if (firstAvailable) return firstAvailable;
        if (sizeIndex !== -1 && activeSize) {
          return variants.find((v) => v.options[sizeIndex] === activeSize) || variants[0] || null;
        }
        return variants[0] || null;
      };

      const preloadImage = (src) => {
        if (!src) return Promise.resolve();

        const cached = imageCache.get(src);
        if (cached && cached.complete) return Promise.resolve();

        return new Promise((resolve) => {
          const img = cached || new Image();
          img.decoding = 'async';
          img.loading = 'eager';
          img.fetchPriority = 'high';
          img.onload = () => resolve();
          img.onerror = () => resolve();

          if (!cached) {
            imageCache.set(src, img);
          }

          if (img.src !== src) {
            img.src = src;
          } else if (img.complete) {
            resolve();
          }
        });
      };

      const resolveRacekitImage = (product, variant = resolveVariant(product)) => {
        if (!product) return '';
        return (
          product.racekitImage ||
          product.featuredImage ||
          (variant && variant.featuredImage) ||
          ''
        );
      };

      const preloadAdjacent = (list, index) => {
        if (!Array.isArray(list) || !list.length) return;
        const nextProduct = list[(index + 1) % list.length];
        const prevProduct = list[(index - 1 + list.length) % list.length];
        preloadImage(resolveRacekitImage(nextProduct));
        preloadImage(resolveRacekitImage(prevProduct));
      };

      const setImage = async (src, direction = 1) => {
        if (!imageEl) return;
        const transitionToken = ++imageTransitionToken;
        const isStale = () => transitionToken !== imageTransitionToken;
        imageEl.style.width = '100%';
        imageEl.style.maxWidth = '100%';
        if (window.matchMedia('(max-width: 749px)').matches) {
          imageEl.style.height = 'auto';
          imageEl.style.maxHeight = 'none';
        } else {
          imageEl.style.height = '100%';
          imageEl.style.maxHeight = '100%';
        }
        imageEl.style.objectFit = 'contain';
        imageEl.style.objectPosition = 'center';

        const nextSrc = src || '';
        const currentSrc = imageEl.dataset.currentSrc || '';
        imageEl.style.setProperty('--race-kit-slide-direction', direction >= 0 ? '1' : '-1');

        if (!nextSrc) {
          if (isStale()) return;
          imageEl.classList.remove('is-loading', 'is-entering', 'is-leaving');
          imageEl.dataset.currentSrc = '';
          imageEl.hidden = true;
          imageEl.src = '';
          return;
        }

        imageEl.hidden = false;

        if (!currentSrc) {
          imageEl.classList.add('is-loading');
          await preloadImage(nextSrc);
          if (isStale()) return;
          imageEl.src = nextSrc;
          imageEl.dataset.currentSrc = nextSrc;
          imageEl.classList.remove('is-loading');
          return;
        }

        if (currentSrc === nextSrc) return;

        imageEl.classList.add('is-loading');
        await preloadImage(nextSrc);
        if (isStale()) return;
        imageEl.src = nextSrc;
        imageEl.dataset.currentSrc = nextSrc;
        imageEl.classList.remove('is-loading');
        imageEl.classList.remove('is-leaving');
        imageEl.classList.remove('is-entering');
        void imageEl.offsetWidth;
        imageEl.classList.add('is-entering');

        imageEl.addEventListener(
          'animationend',
          () => {
            if (isStale()) return;
            imageEl.classList.remove('is-entering');
          },
          { once: true }
        );
      };

      const setActiveFilterButtons = () => {
        filters.forEach((filter) => {
          const filterValue = normalizeSubtypeValue(filter.dataset.filter || '');
          const isAll = filterValue === '';
          const isActive = activeFilter ? filterValue === activeFilter : isAll;
          filter.classList.toggle('is-active', isActive);
        });
      };

      const switchToProductById = (productId, preferredGroupKey = null) => {
        const normalizedProductId = String(productId || '');
        if (!normalizedProductId) return;

        let list = filteredProducts();
        let nextIndex = -1;

        if (preferredGroupKey) {
          nextIndex = list.findIndex(
            (listProduct) => String(listProduct.id) === normalizedProductId && listProduct.groupKey === preferredGroupKey
          );
        }
        if (nextIndex === -1) {
          nextIndex = list.findIndex(
            (listProduct, index) => index > currentIndex && String(listProduct.id) === normalizedProductId
          );
        }
        if (nextIndex === -1) {
          nextIndex = list.findIndex((listProduct) => String(listProduct.id) === normalizedProductId);
        }

        if (nextIndex === -1) {
          const fallbackProduct = productsById.get(normalizedProductId);
          if (!fallbackProduct) return;

          const fallbackSubtypes = normalizeSubtypes(fallbackProduct.subtypes);
          if (activeFilter && !fallbackSubtypes.includes(activeFilter)) {
            activeFilter = fallbackSubtypes[0] || null;
            setActiveFilterButtons();
          }

          list = filteredProducts();
          if (preferredGroupKey) {
            nextIndex = list.findIndex(
              (listProduct) =>
                String(listProduct.id) === normalizedProductId && listProduct.groupKey === preferredGroupKey
            );
          }
          if (nextIndex === -1) {
            nextIndex = list.findIndex((listProduct) => String(listProduct.id) === normalizedProductId);
          }
          if (nextIndex === -1) return;
        }

        currentIndex = nextIndex;
        activeSize = null;
        update(0);
      };

      const renderSwatches = (product) => {
        swatchesEl.innerHTML = '';
        if (!product) return;

        const swatchProducts = getSwatchProducts(product);
        swatchProducts.forEach((swatchProduct) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className =
            'mileoff-race-kit__swatch' + (String(swatchProduct.id) === String(product.id) ? ' is-active' : '');

          const swatchColour = swatchProduct.productColourValue || '';
          const swatchLabel = swatchProduct.productColourName || swatchProduct.title || 'Colour';
          btn.setAttribute('aria-label', swatchLabel);
          if (swatchColour) {
            btn.style.background = swatchColour;
          }
          btn.dataset.productId = String(swatchProduct.id || '');
          btn.dataset.groupKey = product.groupKey || '';

          btn.addEventListener('click', () => {
            switchToProductById(btn.dataset.productId, btn.dataset.groupKey || null);
          });
          swatchesEl.appendChild(btn);
        });
      };

      const renderSizes = (product) => {
        sizesEl.innerHTML = '';
        if (!product) return;
        const sizeData = getSizeData(product);
        sizeData.forEach((size) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mileoff-race-kit__size';
          if (size.value === activeSize) btn.classList.add('is-active');
          if (!size.available) btn.classList.add('is-unavailable');
          btn.disabled = !size.available;
          btn.textContent = size.value;
          btn.setAttribute('aria-label', size.value);
          btn.setAttribute('aria-disabled', size.available ? 'false' : 'true');
          btn.addEventListener('click', () => {
            if (!size.available) return;
            activeSize = size.value;
            update(0);
          });
          sizesEl.appendChild(btn);
        });
      };

      const renderProductTitle = (title = '') => {
        if (!titleEl) return;
        const titleValue = String(title || '').trim();
        titleEl.textContent = '';
        if (!titleValue) return;

        const splitMatch = titleValue.match(/\s+in\s+/i);
        if (!splitMatch || splitMatch.index === undefined || splitMatch.index <= 0) {
          titleEl.textContent = titleValue;
          return;
        }

        const mainTitle = titleValue.slice(0, splitMatch.index).trim();
        const colourTitle = titleValue.slice(splitMatch.index + splitMatch[0].length).trim();
        if (!mainTitle || !colourTitle) {
          titleEl.textContent = titleValue;
          return;
        }

        const mainLine = document.createElement('span');
        mainLine.className = 'mileoff-race-kit__product-title-main';
        mainLine.textContent = mainTitle;

        const colourLine = document.createElement('span');
        colourLine.className = 'mileoff-race-kit__product-title-colour';
        colourLine.textContent = colourTitle;

        titleEl.appendChild(mainLine);
        titleEl.appendChild(colourLine);
      };

      const update = async (direction = 1) => {
        const list = filteredProducts();
        if (!list.length) return;
        if (currentIndex >= list.length) currentIndex = 0;
        const product = list[currentIndex];
        const nextEntryKey = String(product?.entryKey || product?.id || '');
        const nextProductId = String(product?.id || '');
        const productChanged = currentEntryKey !== nextEntryKey;
        currentEntryKey = nextEntryKey;
        currentProductId = nextProductId;

        const sizeData = getSizeData(product);
        if (productChanged) {
          activeSize = getPreferredSizeValue(sizeData);
        } else if (activeSize && !sizeData.some((size) => size.value === activeSize)) {
          activeSize = getPreferredSizeValue(sizeData);
        } else if (!activeSize && sizeData.length) {
          activeSize = getPreferredSizeValue(sizeData);
        }

        const variant = resolveVariant(product);
        const racekit = resolveRacekitImage(product, variant);

        if (block) {
          block.dataset.currentVariantId = variant ? variant.id : '';
          block.dataset.currentVariantAvailable = variant && variant.available ? 'true' : 'false';
          block.dataset.currentProductId = product.id || '';
          block.dataset.currentProductEntryKey = nextEntryKey;
        }
        await setImage(racekit, direction);
        renderProductTitle(product.title || '');

        renderSwatches(product);
        renderSizes(product);

        if (sizeGuideBtn) {
          const sizeGuideValue = typeof product.sizeGuide === 'string' ? product.sizeGuide.trim() : product.sizeGuide;
          const hasSizeGuide = Boolean(sizeGuideValue);
          sizeGuideBtn.hidden = !hasSizeGuide;
          if (!hasSizeGuide && dialog?.open) dialog.close();
        }
        if (dialogImage) {
          const nextGuide = typeof product.sizeGuide === 'string' ? product.sizeGuide.trim() : product.sizeGuide;
          if (nextGuide) {
            dialogImage.src = nextGuide;
          } else {
            dialogImage.removeAttribute('src');
          }
        }

        syncBlockHeight();
        preloadAdjacent(list, currentIndex);
        if (prevBtn) prevBtn.disabled = list.length <= 1;
        if (nextBtn) nextBtn.disabled = list.length <= 1;
      };

      const moveByGroup = (step) => {
        const list = filteredProducts();
        if (!list.length) return;
        if (list.length === 1) {
          update(step);
          return;
        }

        const currentGroupKey = String(list[currentIndex]?.groupKey || '');
        const groupIndexes = [];
        list.forEach((product, index) => {
          if (String(product?.groupKey || '') === currentGroupKey) {
            groupIndexes.push(index);
          }
        });

        if (groupIndexes.length > 1) {
          const firstGroupIndex = groupIndexes[0];
          const lastGroupIndex = groupIndexes[groupIndexes.length - 1];
          if (step > 0 && currentIndex < lastGroupIndex) {
            currentIndex += 1;
            update(step);
            return;
          }
          if (step < 0 && currentIndex > firstGroupIndex) {
            currentIndex -= 1;
            update(step);
            return;
          }
        }

        let nextIndex = currentIndex;
        for (let i = 0; i < list.length; i += 1) {
          nextIndex = (nextIndex + step + list.length) % list.length;
          if (String(list[nextIndex]?.groupKey || '') !== currentGroupKey) {
            currentIndex = nextIndex;
            update(step);
            return;
          }
        }

        const fallbackIndex = (currentIndex + step + list.length) % list.length;
        currentIndex = fallbackIndex;
        update(step);
      };

      const showPrevious = () => {
        moveByGroup(-1);
      };

      const showNext = () => {
        moveByGroup(1);
      };

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          if (filter.disabled) return;
          const value = normalizeSubtypeValue(filter.dataset.filter || '');
          activeFilter = value || null;

          setActiveFilterButtons();
          const currentVisibleEntryKey = String(block.dataset.currentProductEntryKey || '');
          const currentVisibleProductId = String(block.dataset.currentProductId || '');
          let nextFilteredProducts = filteredProducts();
          if (!nextFilteredProducts.length) {
            activeFilter = null;
            setActiveFilterButtons();
            nextFilteredProducts = filteredProducts();
          }
          let matchingIndex = nextFilteredProducts.findIndex(
            (filteredProduct) => String(filteredProduct.entryKey || '') === currentVisibleEntryKey
          );
          if (matchingIndex === -1) {
            matchingIndex = nextFilteredProducts.findIndex(
              (filteredProduct) => String(filteredProduct.id) === currentVisibleProductId
            );
          }
          currentIndex = matchingIndex >= 0 ? matchingIndex : 0;
          update(0);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', showPrevious);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', showNext);
      }

      if (mediaRow) {
        let touchStartX = null;
        let touchStartY = null;
        const swipeThreshold = 40;
        const verticalThreshold = 30;

        mediaRow.addEventListener('touchstart', (event) => {
          if (!event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });

        mediaRow.addEventListener('touchend', (event) => {
          if (touchStartX === null || touchStartY === null || !event.changedTouches.length) return;
          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;
          const deltaX = endX - touchStartX;
          const deltaY = endY - touchStartY;

          if (Math.abs(deltaX) > swipeThreshold && Math.abs(deltaY) < verticalThreshold) {
            if (deltaX < 0) {
              showNext();
            } else {
              showPrevious();
            }
          }

          touchStartX = null;
          touchStartY = null;
        }, { passive: true });
      }

      if (sizeGuideBtn && dialog) {
        sizeGuideBtn.addEventListener('click', () => {
          if (!dialogImage || !dialogImage.src) return;
          dialog.showModal();
        });
      }

      if (dialogClose && dialog) {
        dialogClose.addEventListener('click', () => dialog.close());
      }

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          if (block.classList.contains('is-hidden') || block.classList.contains('is-collapsing')) return;
          closeBtn.disabled = true;
          syncBlockHeight();

          if (!prefersReducedMotion) {
            block.classList.add('is-removing');
          }

          window.setTimeout(() => {
            block.classList.add('is-collapsing');
          }, prefersReducedMotion ? 0 : blockExitSlideMs);

          window.setTimeout(() => {
            block.classList.add('is-hidden');
          }, (prefersReducedMotion ? 0 : blockExitSlideMs) + blockCollapseMs);
        });
      }

      syncBlockHeight();
      update(0);

      if (typeof ResizeObserver !== 'undefined') {
        const blockResizeObserver = new ResizeObserver(() => {
          syncBlockHeight();
        });
        blockResizeObserver.observe(block);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          syncBlockHeight();
        }).catch(() => {});
      }
    });

    const resetBtn = section.querySelector('.mileoff-race-kit__action--reset');
    const addBtn = section.querySelector('.mileoff-race-kit__action--add');

    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        blocks.forEach((block) => {
          if (!block.classList.contains('is-hidden')) return;
          block.classList.remove('is-hidden');
          block.classList.remove('is-removing');
          block.classList.add('is-collapsing');
          const blockCloseBtn = block.querySelector('.mileoff-race-kit__close');
          if (blockCloseBtn instanceof HTMLButtonElement) {
            blockCloseBtn.disabled = false;
          }
          block.style.setProperty('--race-kit-block-max-height', `${block.scrollHeight}px`);
          requestAnimationFrame(() => {
            block.classList.remove('is-collapsing');
          });
        });
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        if (addBtn.disabled) return;
        const items = [];
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const cartSectionIds = new Set();
        blocks.forEach((block) => {
          if (block.classList.contains('is-hidden')) return;
          const variantId = Number(block.dataset.currentVariantId || 0);
          const variantAvailable = block.dataset.currentVariantAvailable === 'true';
          if (variantAvailable && Number.isFinite(variantId) && variantId > 0) {
            items.push({ id: variantId, quantity: 1 });
          }
        });
        cartItemsComponents.forEach((component) => {
          if (component instanceof HTMLElement && component.dataset.sectionId) {
            cartSectionIds.add(component.dataset.sectionId);
          }
        });
        if (!items.length) return;
        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
        try {
          const requestBody = { items };
          if (cartSectionIds.size) {
            requestBody.sections = Array.from(cartSectionIds).join(',');
            requestBody.sections_url = window.location.pathname;
          }

          let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(requestBody)
          });
          let cartResponse = response.ok ? await response.json() : null;

          if (!response.ok && items.length > 1) {
            const addedAny = [];
            for (const item of items) {
              const singleResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({ items: [item] })
              });
              if (singleResponse.ok) {
                addedAny.push(item.id);
              }
            }
            if (!addedAny.length) return;
            response = { ok: true };
            try {
              const cartJsonResponse = await fetch('/cart.js', {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
              });
              if (cartJsonResponse.ok) {
                cartResponse = await cartJsonResponse.json();
              }
            } catch (error) {
              // no-op: we still dispatch the event so the drawer can open.
            }
          }

          if (!response.ok) return;

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartResponse || {},
              sourceId: 'mileoff-race-kit',
              data: {
                source: 'mileoff-race-kit',
                sourceContext: 'quick-add',
                itemCount: items.length,
                sections: cartResponse?.sections
              }
            }
          }));

          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } finally {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mileoff-spotted"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_QUERY = '(max-width: 749px)';
    const SECTION_SELECTOR = '.mileoff-spotted';
    const TRACK_SELECTOR = '[data-mileoff-spotted-track]';
    const initializedSections = new WeakSet();

    const getCenterScrollLeft = (track, item) =>
      item.offsetLeft + item.offsetWidth / 2 - track.clientWidth / 2;

    const getOriginalItems = (track) =>
      Array.from(track.children).filter((child) => !child.hasAttribute('data-clone'));

    const initSection = (section) => {
      if (!(section instanceof HTMLElement) || initializedSections.has(section)) return;
      const track = section.querySelector(TRACK_SELECTOR);
      if (!track) return;
      initializedSections.add(section);

      const mediaQuery = window.matchMedia(MOBILE_QUERY);
      let originalCount = 0;
      let loopSpan = 0;
      let lowerBound = 0;
      let upperBound = 0;
      let scrollTicking = false;
      let recenterTimers = [];
      let resizeObserver = null;
      let resizeRaf = 0;

      const clearRecenterTimers = () => {
        recenterTimers.forEach((timer) => window.clearTimeout(timer));
        recenterTimers = [];
      };

      const teardown = () => {
        track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        track.scrollLeft = 0;
        loopSpan = 0;
        lowerBound = 0;
        upperBound = 0;
        originalCount = 0;
        scrollTicking = false;
        clearRecenterTimers();

        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
      };

      const computeLoopMetrics = () => {
        const allItems = Array.from(track.children);
        if (originalCount < 2 || allItems.length < originalCount * 3) {
          loopSpan = 0;
          lowerBound = 0;
          upperBound = 0;
          return;
        }

        const middleFirst = allItems[originalCount];
        const middleLast = allItems[originalCount * 2 - 1];
        const trailingStart = allItems[originalCount * 2];
        if (!middleFirst || !middleLast || !trailingStart) {
          loopSpan = 0;
          lowerBound = 0;
          upperBound = 0;
          return;
        }

        const firstStep =
          originalCount > 1 ? allItems[1].offsetLeft - allItems[0].offsetLeft : middleFirst.offsetWidth;
        loopSpan = trailingStart.offsetLeft - middleFirst.offsetLeft;
        lowerBound = getCenterScrollLeft(track, middleFirst) - firstStep * 0.5;
        upperBound = getCenterScrollLeft(track, middleLast) + firstStep * 0.5;
      };

      const centerMiddleItem = () => {
        const allItems = Array.from(track.children);
        if (!originalCount || allItems.length < originalCount * 2) return;

        const middleOffset = Math.floor((originalCount - 1) / 2);
        const middleItem = allItems[originalCount + middleOffset];
        if (!middleItem) return;

        const target = getCenterScrollLeft(track, middleItem);
        const previousSnap = track.style.scrollSnapType;
        const previousBehavior = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;

        requestAnimationFrame(() => {
          track.style.scrollSnapType = previousSnap;
          track.style.scrollBehavior = previousBehavior;
        });
      };

      const recenter = () => {
        computeLoopMetrics();
        centerMiddleItem();
      };

      const scheduleRecenter = () => {
        clearRecenterTimers();
        requestAnimationFrame(recenter);
        [80, 220, 450, 800].forEach((delay) => {
          const timer = window.setTimeout(recenter, delay);
          recenterTimers.push(timer);
        });
      };

      const onScroll = () => {
        if (!mediaQuery.matches || !loopSpan || scrollTicking) return;
        scrollTicking = true;

        requestAnimationFrame(() => {
          if (track.scrollLeft < lowerBound) {
            track.scrollLeft += loopSpan;
          } else if (track.scrollLeft > upperBound) {
            track.scrollLeft -= loopSpan;
          }
          scrollTicking = false;
        });
      };

      const setup = () => {
        teardown();
        if (!mediaQuery.matches) return;

        const originals = getOriginalItems(track);
        originalCount = originals.length;
        if (originalCount < 2) return;

        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        originals.forEach((item) => {
          const prependClone = item.cloneNode(true);
          prependClone.setAttribute('data-clone', 'true');
          prependClone.classList.add('is-clone');
          before.appendChild(prependClone);

          const appendClone = item.cloneNode(true);
          appendClone.setAttribute('data-clone', 'true');
          appendClone.classList.add('is-clone');
          after.appendChild(appendClone);
        });

        track.insertBefore(before, track.firstChild);
        track.appendChild(after);

        scheduleRecenter();

        if (typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(() => {
            if (resizeRaf) cancelAnimationFrame(resizeRaf);
            resizeRaf = requestAnimationFrame(recenter);
          });
          resizeObserver.observe(track);
        }
      };

      const onResize = () => {
        if (!mediaQuery.matches || !track.querySelector('[data-clone]')) return;
        requestAnimationFrame(() => {
          computeLoopMetrics();
          if (!loopSpan) return;
          if (track.scrollLeft < lowerBound) {
            track.scrollLeft += loopSpan;
          } else if (track.scrollLeft > upperBound) {
            track.scrollLeft -= loopSpan;
          }
        });
      };

      const onMediaChange = () => {
        setup();
      };

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', onMediaChange);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(onMediaChange);
      }

      window.addEventListener(
        'load',
        () => {
          if (!mediaQuery.matches || !track.querySelector('[data-clone]')) return;
          scheduleRecenter();
        },
        { once: true }
      );

      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener(
          'load',
          () => {
            if (!mediaQuery.matches || !track.querySelector('[data-clone]')) return;
            scheduleRecenter();
          },
          { once: true }
        );
      });

      setup();
    };

    const initAll = (root) => {
      const scope = root instanceof HTMLElement ? root : document;
      scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initAll(document);
        },
        { once: true }
      );
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myloff-quote-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuoteVideo = (root = document) => {
      root.querySelectorAll('.myloff-quote-section').forEach((section) => {
        const playButton = section.querySelector('[data-quote-play]');
        if (!(playButton instanceof HTMLButtonElement)) return;

        const videos = section.querySelectorAll('.myloff-quote-section__video');
        if (!videos.length) return;

        playButton.addEventListener('click', async () => {
          for (const video of videos) {
            if (!(video instanceof HTMLVideoElement)) continue;
            video.muted = true;
            try {
              await video.play();
            } catch (_) {
              // Ignore browser restrictions; keep button visible if playback fails.
              return;
            }
          }

          playButton.hidden = true;
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initQuoteVideo(), { once: true });
    } else {
      initQuoteVideo();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
